const system = [
    {
        path: '/system/user',
        name: 'systemUser',
        component: () => import('@/view/system/user'),
    },
    {
        path: '/system/role',
        name: 'systemRole',
        component: () => import('@/view/system/role'),
    },
    {
        path: '/system/register',
        name: 'systemRegister',
        component: () => import('@/view/system/register'),
    },
    {
        path: '/system/privacy',
        name: 'systemPrivacy',
        component: () => import('@/view/system/privacy'),
    },
    {
        path: '/system/basic',
        name: 'systemBasic',
        component: () => import('@/view/system/basic'),
    },

]
export default system